/**
 * Function that creates the menu logic for the desktop menu
 */
export function desktopMenu() {
	const $menuContainer = $( '.m__desktop-menu' );
	if ( !$menuContainer.length ) {
		return;
	}

	const $document = $( document );
	const $menu = $menuContainer.find( '.m__desktop-menu-container' );
	const $menuTrigger = $menuContainer.find( '.m__desktop-menu-icon' );
	const $menuMask = $( '.m__desktop-menu-mask' );
	const $header = $( '.o__ime-form-header' );

	/**
	 * Show menu and set z-index position on top of the header.
	 */
	function openMenu() {
		$header.css( 'z-index', '5' );
		$header.css( 'padding-bottom', '23px' );
		$menu.show();
		$menuMask.css({ 'height' : `${ $( window ).height() }px` }).show();
	}

	/**
	 * Hide menu and set z-index position on top of the header.
	 */
	function hideMenu() {
		$menu.hide();
		$menuMask.hide();
		$header.css( 'z-index', '1' );
		$header.css( 'padding-bottom', '95px' );
	}

	$menuTrigger.on( 'click', function toggle() {
		if ( $( '.m__desktop-menu-container' ).css( 'display' ) === 'block' ) {
			hideMenu();
		} else {
			openMenu();
		}
	});

	$( $menuMask ).click( function maskClick() {
		hideMenu();
		$document.off( '.hideDocClick' );
	});

	$menu.find( '.m__desktop-menu-container-item' ).on( 'click', () => hideMenu() );
}